'use strict'

exports = module.exports = require('./dagNode')
